export default class Cart {
  _items = [];
  /** @type {Map<int, Item>}*/
  _mapItems = new Map();

  constructor(dependent) {
    this._dependent = dependent;
  }

  mapProductQuantity(products) {
    return products.map((product) => {
      return {
        ...product,
        quantity: this.getProductQuantity(product),
      };
    });
  }

  overFlowDayLimit(product) {
    if (this.dailyLimit <= 0.0) {
      return false;
    }

    return (
      parseFloat(this.amount) + parseFloat(product.price) >
      this.dailyLimitRemaining
    );
  }

  get dailyLimitRemaining() {
    return parseFloat(this._dependent.daily_limit_remaining);
  }

  get dailyLimit() {
    return parseFloat(this._dependent.daily_limit);
  }

  addProduct(product) {
    if (this.overFlowDayLimit(product)) {
      throw new Error(
        `Você atingiu o seu limite diário de R$ ${this.dailyLimit.toFixed(2)}`
      );
    }

    let item = this.getItemByProduct(product);

    if (item !== null && item.canIncrement) {
      item.incrementQuantity();
      return;
    }

    this._pushItem(new Item(product));
  }

  _pushItem(item) {
    this._items.push(item);
    this.items = this._items;
  }

  removeProduct(product) {
    let item = this.getItemByProduct(product);

    if (item === null) {
      return;
    }

    if (item.canDecrement) {
      item.decrementQuantity();
      return;
    }

    this.items = this._items.filter((itemToRemove) =>
      itemToRemove.isNotEqual(item)
    );
  }

  get hasItems() {
    return this._items.length > 0;
  }

  get dotNotHaveItems() {
    return this.hasItems === false;
  }

  get items() {
    return this._items.map((item) => {
      item.product.quantity = item.quantity;
      return item;
    });
  }

  set items(items) {
    this._items = items;

    this._mapItems = this._items.plunk((item) => item.id);
  }

  getItemByProduct(product) {
    if (this._mapItems.has(product.id)) {
      return this._mapItems.get(product.id);
    }
    return null;
  }

  getProductQuantity(product) {
    const item = this.getItemByProduct(product);

    if (item === null) {
      return 0;
    }

    return item.quantity;
  }

  get amount() {
    return this.items
      .map((item) => item.amount)
      .reduce((carry, amount) => carry + amount, 0);
  }

  get length() {
    return this.items
      .map((item) => item.quantity)
      .reduce((carry, quantity) => carry + quantity, 0);
  }
}

class Item {
  product;
  cart;
  quantity = 1;

  constructor(product) {
    this.product = product;
  }

  incrementQuantity() {
    this.quantity++;
  }

  decrementQuantity() {
    this.quantity--;
  }

  equal(item) {
    return item.product.id == this.product.id;
  }

  isNotEqual(item) {
    return this.equal(item) === false;
  }

  get id() {
    return this.product.id;
  }

  get price() {
    return this.product.price;
  }

  get canDecrement() {
    return this.quantity > 1;
  }

  get canIncrement() {
    if (this.product.stock_quantity <= this.quantity) {
      throw new Error(`Limite de estoque do produto atingido`);
    }
    return true;
  }

  get amount() {
    return this.product.price * this.quantity;
  }
}
